import Vue from "vue";
import Settings from "./Settings.vue";
import router from "../../router";
import store from "../../store";
import GetTextPlugin from "vue-gettext";
import translations from "../../../../app/static/js/vue_translations.json";
import PortalVue from 'portal-vue';
import WebFontLoader from '../../plugins/webfontloader';

Vue.use(WebFontLoader);
// import css variables globally
import '@/css/style.scss'
// BOOTSTRAP
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';
Vue.use(BootstrapVue);

// COOKIES
Vue.use(require('vue-cookies'));

// FONT AWESOME PRO ICONS v6.5
/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { all } from '@awesome.me/kit-62561366a1/icons/modules'
library.add(...all)

/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon)

// https://github.com/LinusBorg/portal-vue
Vue.use(PortalVue)

// OVERLAY SCROLLBARS
// https://github.com/KingSora/OverlayScrollbars/tree/master/packages/overlayscrollbars-vue
import 'overlayscrollbars/css/OverlayScrollbars.css';
import { OverlayScrollbarsPlugin } from 'overlayscrollbars-vue';
Vue.use(OverlayScrollbarsPlugin);
// DIRECTIVES
import '@/directives/gk-confirm.directive';
// GLOBAL COMPONENTS
import ConfirmModal from "@/components/ui/ConfirmModal";
import GkBadge from "@/components/GkBadge"
Vue.component('confirm-modal', ConfirmModal)
Vue.component('GkBadge', GkBadge)

// FILTERS: MOVE TO FILTER FOLDER
import '../../filters/filters';

// SENTRY   as seen here: https://docs.sentry.io/platforms/javascript/guides/vue/
import * as Sentry from "@sentry/vue";
import { Vue as VueIntegration } from '@sentry/integrations';
const serverErrorsRegex = new RegExp(
      "500 Internal Server Error|401 Unauthorized|403 Forbidden|404 Not Found|502 Bad Gateway|ResizeObserver|Non-Error promise|XMLHttpRequest",
      "mi"
    );
if (location.hostname !== "localhost" && location.hostname !== "127.0.0.1"){
  Sentry.init({
    Vue: Vue,
    attachStacktrace: true,
    // initialScope: {
    //     user: { id: window.user_id },
    // },
    dsn: "https://77be99f7c67146379ed0b14492ea601a@o18359.ingest.sentry.io/35701",
    integrations: [ new VueIntegration({ Vue, attachProps: true,consoleOutput: true }) ],
    // ignoreErrors: ['ResizeObserver loop limit exceeded'],
    ignoreErrors: [serverErrorsRegex]
  });
  // Attach Sentry to Vue's prototype
  Vue.prototype.$sentry = Sentry;
}

Vue.prototype.$checkPremium = function (is_premium, handler, ...args) {
  if (is_premium) {
    return handler.apply(this, args)
  } else {
    store.commit('togglePremiumModal');
  }
}

// Translation Config
Vue.use(GetTextPlugin, {
  availableLanguages: {
    en: "English",
    es: "Español",
    nl: "Dutch",
    pl: "Polski"
  },
  defaultLanguage: "en",
  translations: translations,
  silent: true
});
Vue.config.productionTip = false;

export const interpolate = Vue.prototype.$gettextInterpolate;
export default Vue.prototype.$gettext;

new Vue({
  router,
  store,
  render: h => h(Settings)
}).$mount("#app");
